import React from "react";
import {BrowserRouter, Routes, Route} from 'react-router-dom';

// Import Pages
import Home from "./views/Home";
import Contato from "./views/Contato";
import Institucional from "./views/Institucional";
import Servicos from "./views/Servicos";

function App() {
  return (
    <main>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} exact />
          <Route path="/contato/" element={<Contato />}  />
          <Route path="/institucional/" element={<Institucional />}  />
          <Route path="/servicos/:slug_servico" element={<Servicos />} exact />
        </Routes>
      </BrowserRouter>
    </main>
  );
}

export default App;
